import React from "react";
import shape1 from "../../images/rsvp/image-1.jpg";
import shape2 from "../../images/rsvp/image-2.jpg";
import RSVPFrom from "../RSVPFrom/RSVPFrom";

interface RsvpSectionProps {
  rClass?: string;
}

const RsvpSection: React.FC<RsvpSectionProps> = ({ rClass }) => {
  return (
    <section className={`wpo-contact-section ${rClass || ""}`}>
      <div className="container-fluid">
        <div className="contact-wrap">
          <div
            className="contact-title wow fadeInUp"
            data-wow-duration="1200ms"
          >
            <h2>
              Welcome To Our Big Day
              <img src={shape1} alt="decorative shape" className="hover-image" />
              <img
                src={shape2}
                alt="decorative shape"
                className="hover-image s2"
              />
            </h2>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div
                className="wpo-contact-section-wrapper wow fadeInRightSlow"
                data-wow-duration="1200ms"
              >
                <div className="wpo-contact-form-area">
                  <RSVPFrom />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RsvpSection;
